import { jsx as _jsx } from "react/jsx-runtime";
import { lazy } from "react";
var MandantDashBoard = lazy(function () { return import("@pages/common/dashboard/UserDashBoard"); });
var StatusDBList = lazy(function () { return import("@pages/status/StatusDBList"); });
var LogDbList = lazy(function () { return import("@pages/log/LogDbList"); });
// SEND messages
var Lodgepurchaselist = lazy(function () { return import("@pages/messages/send/lodgepurchase/Lodgepurchaselist"); });
var LodgePurchaseOld = lazy(function () { return import("@pages/messages/send/lodgepurchase/LodgePurchaseOld"); });
var RequestPurchaseIdsNew = lazy(function () { return import("@pages/messages/send/requestPurchaseIds/RequestPurchaseIdsNew"); });
var RequestPurchaseIdsList = lazy(function () { return import("@pages/messages/send/requestPurchaseIds/RequestPurchaseIdsList"); });
var AkzsRequestList = lazy(function () { return import("@pages/messages/send/akzs/AkzsRequestList"); });
var AkzsRequestNew = lazy(function () { return import("@pages/messages/send/akzs/AkzsRequestNew"); });
// REPLY messages
var ProcessAkzsList = lazy(function () { return import("@pages/messages/receive/process_akzs/ProcessAkzsList"); });
var ProcessAkzsDetail = lazy(function () { return import("@pages/messages/receive/process_akzs/ProcessAkzsDetail"); });
var PurchaseProcessIds = lazy(function () { return import("@pages/messages/receive/purchaseprocessids/PurchaseProcessIds"); });
var PurchaseProcessIdsList = lazy(function () {
    return import("@pages/messages/receive/purchaseprocessids/PurchaseProcessIdsList");
});
var ProcessPurchaseResultList = lazy(function () {
    return import("@pages/messages/receive/processPurchaseResult/ProcessPurchaseResultList");
});
var ProcessPurchaseResult = lazy(function () {
    return import("@pages/messages/receive/processPurchaseResult/ProcessPurchaseResult");
});
var ErrorList = lazy(function () { return import("@pages/messages/receive/error/ErrorList"); });
var ErrorResult = lazy(function () { return import("@pages/messages/receive/error/Error"); });
var LodgePurchaseNew = lazy(function () { return import("@pages/messages/send/lodgepurchase/LodgePurchaseNew"); });
var AddressList = lazy(function () { return import("@pages/address/AddressList"); });
var OptionTypeList = lazy(function () { return import("@pages/options/OptionsTypeList"); });
var OptionDbList = lazy(function () { return import("@pages/options/OptionsDbList"); });
var DeclarationStatistics = lazy(function () { return import("@pages/statistics/DeclarationStatistics"); });
export var userRoutes = [
    {
        path: "dashboard",
        element: _jsx(MandantDashBoard, {}),
    },
    {
        path: "messages/lodgepurchase/list",
        element: _jsx(Lodgepurchaselist, {}),
    },
    {
        path: "messages/lodgepurchase/old",
        element: _jsx(LodgePurchaseOld, {}),
    },
    {
        path: "messages/lodgepurchase/new",
        element: _jsx(LodgePurchaseNew, {}),
    },
    {
        path: "status",
        element: _jsx(StatusDBList, {}),
    },
    {
        path: "log",
        element: _jsx(LogDbList, {}),
    },
    {
        path: "messages/akzs/list",
        element: _jsx(AkzsRequestList, {}),
    },
    {
        path: "messages/akzs/new",
        element: _jsx(AkzsRequestNew, {}),
    },
    {
        path: "messages/requestPurchaseIds/list",
        element: _jsx(RequestPurchaseIdsList, {}),
    },
    {
        path: "messages/requestPurchaseIds/new",
        element: _jsx(RequestPurchaseIdsNew, {}),
    },
    {
        path: "messages/receive/akzs/detail",
        element: _jsx(ProcessAkzsDetail, {}),
    },
    {
        path: "messages/receive/akzs/list",
        element: _jsx(ProcessAkzsList, {}),
    },
    {
        path: "messages/receive/purchaseprocessids/list",
        element: _jsx(PurchaseProcessIdsList, {}),
    },
    {
        path: "messages/receive/purchaseprocessids/details",
        element: _jsx(PurchaseProcessIds, {}),
    },
    {
        path: "messages/receive/processpurchaseresult/list",
        element: _jsx(ProcessPurchaseResultList, {}),
    },
    {
        path: "messages/receive/processpurchaseresult/details",
        element: _jsx(ProcessPurchaseResult, {}),
    },
    {
        path: "messages/receive/processerror/list",
        element: _jsx(ErrorList, {}),
    },
    {
        path: "messages/receive/processerror/details",
        element: _jsx(ErrorResult, {}),
    },
    {
        path: "address/list",
        element: _jsx(AddressList, {}),
    },
    {
        path: "options",
        element: _jsx(OptionTypeList, {}),
    },
    {
        path: "options/list",
        element: _jsx(OptionDbList, {}),
    },
    {
        path: "declaration-statistics",
        element: _jsx(DeclarationStatistics, {}),
    },
];
